import * as yup from 'yup';
import { RenderConfig, Row, TextInput } from 'commons-ui';
import { FORM_FIELD_KEYS } from '../constants';

export const validateionSchema = yup.object().shape({
	name: yup.string().required('Name is a required field')
});

// form builder that gives types of form fields
export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.NAME)
		.setLabel('Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.NAME)];
